{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.DataGrid.libjs;

interface

{$IFDEF PAS2JS}
{$mode DELPHI}
{$modeswitch externalclass}
{$ENDIF}

uses
  WEBLib.DataGrid.Common,
  Classes, web, JS, WEBLib.Controls,
  Generics.Collections, Generics.Defaults,
  Vcl.Controls,
  Types, System.SysUtils, jsdelphisystem;
type
  TJSCallbackHandler = reference to procedure(Event: TEventListenerEvent);

  TConsole = class {$IFDEF PAS2JS} external name 'console'{$ENDIF} (TJSObject)
  public
    class function log(Value: TJSValue) : String; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    class function error(Value: TJSValue) : String; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
  end;


  TEmbeddedJavaScriptLoad = function(): String of object;
  TEmbeddedJavaScript = class abstract
  public

    function ModuleName: String; virtual; abstract;
    function Source: String; virtual; abstract;
    function GlobalVariableName: String; virtual; abstract;

  end;
  TRemoteJavaScript = class(TEmbeddedJavaScript)
  private
    FModuleName: String;
    FSource: String;
    FGlobalVariableName: String;
  public
    constructor Create(AModuleName: String; AGlobalVariableName: String; ASource: String); reintroduce; 
    function ModuleName: String; override;
    function Source: String; override;
    function GlobalVariableName: String; override;  
  end;

{$REGION 'Module Loader'}
{$REGION 'Module Collection'}
  TTMSModuleCollectionItem = class(TCollectionItem)
  strict private
    FModuleName: String;
    FURL: String;
    FGlobalVariableName: String;

    FLoaded: Boolean;
    FEmbeddedJavaScript: TEmbeddedJavaScript;
  public
    constructor Create(ACollection: TCollection); override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;

    property ModuleName: String read FModuleName write FModuleName;
    property ModuleURL: String read FURL write FURL;
    property GlobalVariableName: String read FGlobalVariableName write FGlobalVariableName;

    property Loaded: Boolean read FLoaded write FLoaded;
    property EmbeddedJavaScript: TEmbeddedJavaScript read FEmbeddedJavaScript write FEmbeddedJavaScript;
  end;
  TTMSModuleCollection = class(TOwnedCollection)
  private
    function GetItem(Index: integer): TTMSModuleCollectionItem; reintroduce;
    procedure SetItem(Index: integer; const Value: TTMSModuleCollectionItem);
  public
    constructor Create(AOwner: TComponent); reintroduce; overload;
    function Add: TTMSModuleCollectionItem; reintroduce;
    function Insert(Index: integer): TTMSModuleCollectionItem; reintroduce;
    property Items[Index: integer]: TTMSModuleCollectionItem read GetItem write SetItem;
    function HasModule(const ModuleName: String): Boolean;
    function FindModule(const ModuleName: String): TTMSModuleCollectionItem;
  end;
{$ENDREGION}
  TTMSModuleLoader = class
  private
    FModules: TTMSModuleCollection;
    FStaticModules: TTMSModuleCollection;
    class var FInstance: TTMSModuleLoader;
    class function GetUrl(URL: String): String; static;
    class function FindHead(InDesigner: Boolean): TJSElement; static;
  protected
  public
    constructor Create;
    destructor Destroy; override;
    class procedure LoadModules(InDesigner: Boolean = False);
    class procedure AddModule(const Name: String; const URL: String = ''; const GlobalVarName: String = ''; const UseExternalLink: Boolean = False);
    class function LoadModule(const Name: String; InDesigner: Boolean = False): Boolean;
    class procedure RegisterEmbeddedJavaScript(const EmbeddedJavaScript: TEmbeddedJavaScript);

    class procedure AddScriptLink(const Name: String; const Link: String; InDesigner: Boolean; Callback: TJSCallbackHandler = nil);
    class procedure AddScriptSource(const Name: String; const Source: String; InDesigner: Boolean);
    property Modules: TTMSModuleCollection read FModules;
    property StaticModules: TTMSModuleCollection read FStaticModules;
  end;
{$ENDREGION}

  // This is to work around the limitations of the existing TJSArray implementation.
  TJSArrayEx = class{$IFDEF PAS2JS} external name 'Array' {$ENDIF}(TJSArray)
  public
    class function _of(): TJSArray varargs{$IFNDEF PAS2JS} cdecl{$ENDIF}; reintroduce;{$IFNDEF PAS2JS} virtual; abstract;{$ENDIF}{$IFDEF PAS2JS} external name 'of';{$ENDIF}
    function unshift(aElement: TJSValue): NativeInt{$IFDEF PAS2JS} external name 'unshift' {$ENDIF}; reintroduce;{$IFNDEF PAS2JS} virtual; abstract;{$ENDIF}
    function splice(aStart: NativeInt; aDeleteCount: NativeInt; aElement: TJSValue): TJSArray{$IFDEF PAS2JS} external name 'splice'{$ENDIF}; overload;{$IFNDEF PAS2JS} virtual; abstract;{$ENDIF}
  end;

  TJSMutationObserver = class;
  TJSMutationObserverConfig = class
  public
    childList: Boolean;
    subtree: Boolean;
  end;
  TJSMutationObserverCallback = reference to procedure (mutationList: TJSArray; observer : TJSMutationObserver);
  TJSMutationObserver = class {$IFDEF PAS2JS} external name 'MutationObserver'{$ENDIF} (TJSObject)
    constructor new(Executor : TJSMutationObserverCallback); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure disconnect; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    procedure observe(element: TJSObject; config: TJSMutationObserverConfig); {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
  end;

  TJSFetchResponse = class (TJSObject)
  public
    Body: TJSObject {$IFDEF PAS2JS}external name 'body'{$ENDIF};
    BodyUsed: Boolean {$IFDEF PAS2JS}external name 'bodyUsed'{$ENDIF};
    Headers: TJSObject {$IFDEF PAS2JS}external name 'headers'{$ENDIF};
    Ok: Boolean {$IFDEF PAS2JS}external name 'ok'{$ENDIF};
    Redirected: Boolean {$IFDEF PAS2JS}external name 'redirected'{$ENDIF};
    Status: Integer {$IFDEF PAS2JS}external name 'status'{$ENDIF};
    StatusText: String {$IFDEF PAS2JS}external name 'statusText'{$ENDIF};
    Type_: String {$IFDEF PAS2JS}external name 'type'{$ENDIF};
    Url: String {$IFDEF PAS2JS}external name 'url'{$ENDIF};
    function Json(): TJSObject {$IFDEF PAS2JS}external name 'json'{$ENDIF}; overload; {$IFDEF PAS2JS}async;{$ENDIF}{$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}

    function Text(): String {$IFDEF PAS2JS}external name 'text'{$ENDIF}; {$IFDEF PAS2JS}async;{$ENDIF}{$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
  end;

  TJSFetch = class {$IFDEF PAS2JS}external name 'window'{$ENDIF} (TJSObject)
  public
    class function fetch(resource: string; init: TJSObject): TJSPromise {$IFDEF PAS2JS}external name 'fetch'{$ENDIF}; overload; {$IFDEF PAS2JS}async;{$ENDIF}{$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    class function fetch(resource: string): TJSPromise {$IFDEF PAS2JS}external name 'fetch'{$ENDIF}; overload; {$IFDEF PAS2JS}async;{$ENDIF}{$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    class function fetch(resource: TJSObject; init: TJSObject): TJSPromise {$IFDEF PAS2JS}external name 'fetch'{$ENDIF}; overload; {$IFDEF PAS2JS}async;{$ENDIF}{$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
    class function fetch(resource: TJSObject): TJSPromise {$IFDEF PAS2JS}external name 'fetch'{$ENDIF}; overload; {$IFDEF PAS2JS}async;{$ENDIF}{$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
  end;

{$REGION 'TStringComparer'}
{$IFDEF PAS2JS}
  TStringComparer = class
    class function Ordinal: IComparer<String>;
  end;
{$ENDIF}
{$ENDREGION}

  TJSSetTimeoutCallBackRef = reference to procedure();
  TJSSetTimeoutCallBackRef1 = reference to procedure(param1: TJSValue);
  TJSSetTimeoutCallBackRef2 = reference to procedure(param1: TJSValue; param2: TJSValue);
  TJSSetTimeoutCallBackRef3 = reference to procedure(param1: TJSValue; param2: TJSValue; param3: TJSValue);
  TJSSetTimeoutCallBack = procedure() of object;
  TJSSetTimeoutCallBack1 = procedure(param1: TJSValue) of object;
  TJSSetTimeoutCallBack2 = procedure(param1: TJSValue; param2: TJSValue) of object;
  TJSSetTimeoutCallBack3 = procedure(param1: TJSValue; param2: TJSValue; param3: TJSValue) of object;

  function _typeof(Value: TJSValue) : String {$IFDEF PAS2JS} external name 'typeof' {$ENDIF}; overload;
  function _typeof(Value: Pointer) : String {$IFDEF PAS2JS} external name 'typeof' {$ENDIF}; overload;
  function _NotNullOrUndefined(Value: TJSValue): Boolean;
  function _isInteger(Value: TJSValue): Boolean {$IFDEF PAS2JS} external name 'Number.isInteger' {$ENDIF}; overload;
  function _parseIntValue(Value: TJSValue): Integer {$IFDEF PAS2JS} external name 'parseInt' {$ENDIF}; overload;
  function _isNaN(Value: TJSValue): Boolean {$IFDEF PAS2JS} external name 'Number.isNaN' {$ENDIF}; overload;
  function _setTimeout(functionRef: TJSSetTimeoutCallBack; delay: Integer) : Integer {$IFDEF PAS2JS} external name 'setTimeout' {$ENDIF}; overload;
  function _setTimeout(functionRef: TJSSetTimeoutCallBack1; delay: Integer; param1: TJSValue) : Integer {$IFDEF PAS2JS} external name 'setTimeout' {$ENDIF}; overload;
  function _setTimeout(functionRef: TJSSetTimeoutCallBack2; delay: Integer; param1: TJSValue; param2: TJSValue) : Integer {$IFDEF PAS2JS} external name 'setTimeout' {$ENDIF}; overload;
  function _setTimeout(functionRef: TJSSetTimeoutCallBack3; delay: Integer; param1: TJSValue; param2: TJSValue; param3: TJSValue) : Integer {$IFDEF PAS2JS} external name 'setTimeout' {$ENDIF}; overload;
  function _setTimeout(functionRef: TJSSetTimeoutCallBackRef; delay: Integer) : Integer {$IFDEF PAS2JS} external name 'setTimeout' {$ENDIF}; overload;
  function _setTimeout(functionRef: TJSSetTimeoutCallBackRef1; delay: Integer; param1: TJSValue) : Integer {$IFDEF PAS2JS} external name 'setTimeout' {$ENDIF}; overload;
  function _setTimeout(functionRef: TJSSetTimeoutCallBackRef2; delay: Integer; param1: TJSValue; param2: TJSValue) : Integer {$IFDEF PAS2JS} external name 'setTimeout' {$ENDIF}; overload;
  function _setTimeout(functionRef: TJSSetTimeoutCallBackRef3; delay: Integer; param1: TJSValue; param2: TJSValue; param3: TJSValue) : Integer {$IFDEF PAS2JS} external name 'setTimeout' {$ENDIF}; overload;
  procedure _clearTimeout(timeoutID: Integer) {$IFDEF PAS2JS} external name 'clearTimeout' {$ENDIF}; overload;
  function _await(Value: TJSValue) : Pointer {$IFDEF PAS2JS} external name 'await' {$ENDIF}; overload;
  function _Object_keys(Value: TJSValue) : TJSArray {$IFDEF PAS2JS} external name 'Object.keys' {$ENDIF}; overload;

  // Dummy functions to get rid of compiler warnings
  procedure _nowarn(var Value: Boolean) {$IFDEF PAS2JS} external name 'typeof' {$ENDIF}; overload;
  procedure _nowarn(var Value: LongInt) {$IFDEF PAS2JS} external name 'typeof' {$ENDIF}; overload;
  procedure _nowarn(var Value: Double) {$IFDEF PAS2JS} external name 'typeof' {$ENDIF}; overload;
  procedure _nowarn(var Value: String) {$IFDEF PAS2JS} external name 'typeof' {$ENDIF}; overload;
  procedure _nowarn(var Value: TJSValue) {$IFDEF PAS2JS} external name 'typeof' {$ENDIF}; overload;
  procedure _nowarn(var Value: TJSObject) {$IFDEF PAS2JS} external name 'typeof' {$ENDIF}; overload;
  procedure _nowarn(var Value: TJSArray) {$IFDEF PAS2JS} external name 'typeof' {$ENDIF}; overload;
  procedure _nowarn(var Value: Pointer) {$IFDEF PAS2JS} external name 'typeof' {$ENDIF}; overload;

  procedure _CreateInitialize(AComponent: TComponent);
  function _Bind(Sender: Pointer): Pointer;

implementation

type

  TJSBindingCallback = class
  public
    function bind(Sender: Pointer): Pointer{$IFDEF PAS2JS} external name 'bind'{$ENDIF}; {$IFNDEF PAS2JS}virtual; abstract;{$ENDIF}
  end;



function _NotNullOrUndefined(Value: TJSValue): Boolean;
begin
  Result := False;
  if (_typeof(Value) <> 'undefined') and
     (Value <> nil) then
    Result := True;
end;





{$REGION 'Module Loader'}

{ TTMSModuleLoader }

constructor TTMSModuleLoader.Create;
begin
  inherited;
  FModules := TTMSModuleCollection.Create(nil);
  FStaticModules := TTMSModuleCollection.Create(nil);
end;

destructor TTMSModuleLoader.Destroy;
begin
  if Assigned(FModules) then
    FreeAndNil(FModules);
  if Assigned(FStaticModules) then
    FreeAndNil(FStaticModules);
  inherited;
end;

class function TTMSModuleLoader.FindHead(InDesigner: Boolean): TJSElement;
var
  innerObjectElement, headElement: TJSElement;
  htmlDocument: TJSDocument;
begin
  if InDesigner then
  begin
    innerObjectElement := document.getElementById('projecthtml');
    if _NotNullOrUndefined(innerObjectElement) then
    begin
      htmlDocument := innerObjectElement.ownerDocument;
      if _NotNullOrUndefined(htmlDocument) then
      begin
        headElement := htmlDocument.head;
        if _NotNullOrUndefined(headElement) then
        begin
          Result := headElement;
          Exit;
        end;
      end;
    end;
  end;
  Result := document.head;
end;

class procedure TTMSModuleLoader.AddScriptSource(const Name: String; const Source: String; InDesigner: Boolean);
var
  id: string;
  script: TJSHTMLScriptElement;

begin
  id := ClassName+'-'+Name+'-src';

  if not Assigned(document.getElementById(id)) then
  begin
    script := TJSHTMLScriptElement(document.createElement('script'));
    script.id := id;
    script.innerHTML := source;
    script.type_ := 'text/javascript';
    FindHead(InDesigner).appendChild(script);
  end;
end;

class procedure TTMSModuleLoader.AddScriptLink(const Name: String; const Link: String; InDesigner: Boolean; Callback: TJSCallbackHandler = nil);
var
  id: string;
  script: TJSHTMLScriptElement;
begin
  id := ClassName+'-'+Name;

  if not Assigned(document.getElementById(id)) then
  begin
    script := TJSHTMLScriptElement(document.createElement('script'));
    script.id := id;
    script.src := link;
    script.type_ := 'text/javascript';
    script.async := False;
    {$IFDEF PAS2JS}asm
    script.onreadystatechange = function(e) {
      if (this.readyState == 'complete') {
        if (typeof(Callback) == "function") {
          Callback(e);
        }
      }
    }
    script.onload = function(e) {
      if (typeof(Callback) == "function") {
        Callback(e);
      }
    };
    end;{$ENDIF}
    FindHead(InDesigner).appendChild(script);
  end;
end;

/// <summary>
///  Adds a module to the list of modules to be loaded.  If the name
///  matches a static module that has been pre-loaded, then it is
///  used instead of trying to load it from the URL.
/// </summary>
/// <param name="Name">
///  Name of the module to be loaded.
/// </param>
/// <param name="URL">
///   The URL where the module can be loaded
/// </param>
class procedure TTMSModuleLoader.AddModule(
    const Name: String;
    const URL: String = '';
    const GlobalVarName: String = '';
    const UseExternalLink: Boolean = False);
var
  StaticModule: TTMSModuleCollectionItem;
begin
  if not Assigned(FInstance) then
    FInstance := TTMSModuleLoader.Create;
  if not FInstance.Modules.HasModule(Name) then
  begin
    with FInstance.Modules.Add do
    begin
      StaticModule := FInstance.StaticModules.FindModule(Name);
      if (StaticModule <> nil) and (not UseExternalLink) then
      begin
        ModuleName := StaticModule.ModuleName;
        ModuleURL := StaticModule.ModuleURL;
        if GlobalVarName <> '' then
          GlobalVariableName := GlobalVarName
        else
          GlobalVariableName := StaticModule.GlobalVariableName;

        EmbeddedJavaScript := StaticModule.EmbeddedJavaScript;
      end
        else
      begin
        ModuleName := Name;
        ModuleURL := URL;
        if GlobalVarName <> '' then
          GlobalVariableName := GlobalVarName
        else
        begin
          if (StaticModule <> nil) and (StaticModule.GlobalVariableName <> '') then
            GlobalVariableName := StaticModule.GlobalVariableName
          else
            GlobalVariableName := Name;
        end;

        EmbeddedJavaScript := nil;
        EmbeddedJavaScript := TRemoteJavaScript.Create(ModuleName, GlobalVariableName, GetUrl(ModuleUrl));
      end;
    end;
  end;
end;

class function TTMSModuleLoader.GetUrl(URL: String): String;
var
  Request: TJSXMLHttpRequest;
begin
  //WARNING: The use of XMLHttpRequest in synchronous mode has been officially
  //         deprecated since 2023!
  //         We are using it here since there is no other simple way to load
  //         an external script from the Pascal components and have it loaded
  //         in time before the Pascal components initializes at this time.
  Result := '';
  if URL <> '' then
  begin
    Request := TJSXMLHttpRequest.new;
    Request.open('GET', URL, False);
    Request.send;
    if Request.Status = 200 then
      Result := Request.responseText;
  end;
end;


class function TTMSModuleLoader.LoadModule(const Name: String; InDesigner: Boolean = False): Boolean;
var
  Module: TTMSModuleCollectionItem;
  Source: String;
  Element: TJSElement;

  procedure OnRemoteSourceLoaded(Event: TEventListenerEvent);
  begin
    if Assigned(Module) then
      Module.Loaded := True;
  end;
begin
  Result := False;
  if not Assigned(FInstance) then
    FInstance := TTMSModuleLoader.Create;

  Module := FInstance.Modules.FindModule(Name);
  if Module <> nil then
  begin
    Result := Module.Loaded;

    if not Module.Loaded then
    begin
      if Module.EmbeddedJavaScript <> nil then
      begin
        // Local source
        Source := Module.EmbeddedJavaScript.Source;
        if Module.GlobalVariableName <> '' then
        begin
          Source := '(function() { var exports = {}; var module = {};' + #$D#$A + Source;
          Source := Source + 'if (typeof(module.exports) != "undefined") { window.document.'
            + Module.GlobalVariableName + ' = module.exports; }'
            + ' else if (typeof(exports) != "undefined") { window.document.'
            + Module.GlobalVariableName + ' = exports; }'
            + '})();';
        end;
        FInstance.AddScriptSource(Module.ModuleName, Source, InDesigner);
        Module.Loaded := True;
        Result := True;
      end
        else if Module.ModuleURL <> '' then
      begin
        // Remote source
        FInstance.AddScriptLink(Module.ModuleName, Module.ModuleURL, InDesigner {$IFDEF PAS2JS}, @OnRemoteSourceLoaded{$ENDIF});

        Result := True;
      end;

      if Module.Loaded and InDesigner then
      begin

        Element := document.getElementById('projecthtml');
        if (_typeof(Element) = 'object') and
           (_typeof(Element.ownerDocument) = 'object') then
        begin
          document[Module.GlobalVariableName] := Element.ownerDocument[Module.GlobalVariableName];
        end;
      end;

    end;
  end;
end;

/// <summary>
///   Load all the modules that has been added to the module loader
///   using AddModule().
/// </summary>
class procedure TTMSModuleLoader.LoadModules(InDesigner: Boolean = False);
var
  Count: Integer;
  I: Integer;
  Module: TTMSModuleCollectionItem;
  Modules: TTMSModuleCollection;
//  Element: TJSElement;
begin
  if Assigned(FInstance) then
  begin
    Modules := FInstance.Modules;
    Count := Modules.Count;
    for I := 0 to Count - 1 do
    begin
      Module := Modules.Items[I];
      LoadModule(Module.ModuleName, InDesigner);

//      if Module.Loaded and InDesigner then
//      begin
//{$REGION 'AC_DEBUG'}{$IFDEF AC_DEBUG}
////AC:NOTE - This is required because WEBLib.DataGrid.Options calls
////          TEmbeddedJSCellComponents.TcrTextRendererComponent which
////          translates to document.agCellComp.TcrTextRendererComponent.
////          The problem is that within the new TMS web designer, the
////          document is not the same as the root document.
//{$ENDIF AC_DEBUG}{$ENDREGION 'AC_DEBUG'}
//        Element := document.getElementById('projecthtml');
//        if (_typeof(Element) = 'object') and
//           (_typeof(Element.ownerDocument) = 'object') then
//        begin
//          document[Module.GlobalVariableName] := Element.ownerDocument[Module.GlobalVariableName];
//        end;
//      end;
    end;

  end;
end;

class procedure TTMSModuleLoader.RegisterEmbeddedJavaScript(
  const EmbeddedJavaScript: TEmbeddedJavaScript);
var
  CurrentModule: TTMSModuleCollectionItem;
begin
  if not Assigned(FInstance) then
    FInstance := TTMSModuleLoader.Create;
  if Assigned(FInstance) then
  begin
    CurrentModule := FInstance.StaticModules.Add;
    CurrentModule.ModuleName := EmbeddedJavaScript.ModuleName;
    CurrentModule.EmbeddedJavaScript := EmbeddedJavaScript;
    CurrentModule.GlobalVariableName := EmbeddedJavaScript.GlobalVariableName;
  end;
end;

{$REGION 'Module Collection'}
{ TTMSModuleCollectionItem }

procedure TTMSModuleCollectionItem.Assign(Source: TPersistent);
var
  SourceItem: TTMSModuleCollectionItem;
begin
  inherited;
  SourceItem := Source as TTMSModuleCollectionItem;
  if SourceItem <> nil then
  begin
    FModuleName := SourceItem.FModuleName;
    FURL := SourceItem.FURL;
    FGlobalVariableName := SourceItem.FGlobalVariableName;

    FEmbeddedJavaScript := SourceItem.FEmbeddedJavaScript;
  end;
end;

constructor TTMSModuleCollectionItem.Create(ACollection: TCollection);
begin
  inherited;

end;

destructor TTMSModuleCollectionItem.Destroy;
begin

  inherited;
end;

{ TTMSModuleCollection }

function TTMSModuleCollection.Add: TTMSModuleCollectionItem;
begin
  Result := TTMSModuleCollectionItem(inherited Add);
end;

constructor TTMSModuleCollection.Create(AOwner: TComponent);
begin
  inherited Create(AOwner, TTMSModuleCollectionItem);
end;

function TTMSModuleCollection.FindModule(
  const ModuleName: String): TTMSModuleCollectionItem;
var
  I: Integer;
begin
  Result := nil;
  for I := 0 to Self.Count - 1 do
  begin
    if Items[I].ModuleName = ModuleName then
    begin
      Result := Items[I];
      Exit;
    end;
  end;
end;

function TTMSModuleCollection.GetItem(Index: integer): TTMSModuleCollectionItem;
begin
  Result := TTMSModuleCollectionItem(inherited Items[Index]);
end;

function TTMSModuleCollection.HasModule(const ModuleName: String): Boolean;
begin
  Result := (FindModule(ModuleName) <> nil);
end;

function TTMSModuleCollection.Insert(Index: integer): TTMSModuleCollectionItem;
begin
  Result := TTMSModuleCollectionItem(inherited Insert(Index));
end;

procedure TTMSModuleCollection.SetItem(Index: integer;
  const Value: TTMSModuleCollectionItem);
begin
  inherited Items[Index] := Value;
end;

{$ENDREGION}

{$ENDREGION}


{$IFNDEF PAS2JS}
function _typeof(Value: TJSValue) : String; begin Result := ''; end;
function _typeof(Value: Pointer) : String; begin Result := ''; end;
function _isInteger(Value: TJSValue): Boolean; begin Result := False; end;
function _parseIntValue(Value: TJSValue): Integer; begin Result := 0; end;
function _isNaN(Value: TJSValue): Boolean; begin Result := False; end;
function _setTimeout(functionRef: TJSSetTimeoutCallBack; delay: Integer) : Integer; begin Result := 0; end;
function _setTimeout(functionRef: TJSSetTimeoutCallBack1; delay: Integer; param1: TJSValue) : Integer; begin Result := 0; end;
function _setTimeout(functionRef: TJSSetTimeoutCallBack2; delay: Integer; param1: TJSValue; param2: TJSValue) : Integer; begin Result := 0; end;
function _setTimeout(functionRef: TJSSetTimeoutCallBack3; delay: Integer; param1: TJSValue; param2: TJSValue; param3: TJSValue) : Integer; begin Result := 0; end;
function _setTimeout(functionRef: TJSSetTimeoutCallBackRef; delay: Integer) : Integer; begin Result := 0; end;
function _setTimeout(functionRef: TJSSetTimeoutCallBackRef1; delay: Integer; param1: TJSValue) : Integer; begin Result := 0; end;
function _setTimeout(functionRef: TJSSetTimeoutCallBackRef2; delay: Integer; param1: TJSValue; param2: TJSValue) : Integer; begin Result := 0; end;
function _setTimeout(functionRef: TJSSetTimeoutCallBackRef3; delay: Integer; param1: TJSValue; param2: TJSValue; param3: TJSValue) : Integer; begin Result := 0; end;
procedure _clearTimeout(timeoutID: Integer); begin end;
function _await(Value: TJSValue) : Pointer; begin Result := nil; end;
function _Object_keys(Value: TJSValue) : TJSArray; begin Result := nil; end;

procedure _nowarn(var Value: Boolean); begin end;
procedure _nowarn(var Value: Longint); begin end;
procedure _nowarn(var Value: Double); begin end;
procedure _nowarn(var Value: String); begin end;
procedure _nowarn(var Value: TJSValue); begin end;
procedure _nowarn(var Value: TJSObject); begin end;
procedure _nowarn(var Value: TJSArray); begin end;
procedure _nowarn(var Value: Pointer); begin end;
{$ENDIF}

procedure _CreateInitialize(AComponent: TComponent);
begin
{$IFDEF PAS2JS}
  asm {
  if (typeof(AComponent.CreateInitialize) == "function")
    AComponent.CreateInitialize;
  } end;
{$ENDIF}
end;

function _Bind(Sender: Pointer): Pointer;
begin
  Result := TJSBindingCallback(Sender).bind(Sender);
end;

{$REGION 'TStringComparer'}
{$IFDEF PAS2JS}
{ TStringComparer }

class function TStringComparer.Ordinal: IComparer<String>;
begin
  Result := TComparer<String>.Construct(
      function(const Left, Right: String): Integer
      begin
        if Left > Right then
          Result := 1
        else if Left < Right then
          Result := -1
        else
          Result := 0;
      end
    );

end;
{$ENDIF}
{$ENDREGION}


{ TRemoteJavaScript }

constructor TRemoteJavaScript.Create(AModuleName, AGlobalVariableName,
  ASource: String);
begin
  inherited Create;
  FModuleName := AModuleName;
  FSource := ASource;
  FGlobalVariableName := AGlobalVariableName;
end;

function TRemoteJavaScript.GlobalVariableName: String;
begin
  Result := FGlobalVariableName;
end;

function TRemoteJavaScript.ModuleName: String;
begin
  Result := FModuleName;
end;

function TRemoteJavaScript.Source: String;
begin
  Result := FSource;
end;


end.


